module.exports = __webpack_public_path__ + "static/media/math.951e1f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Aya/math.png
// module id = 156
// module chunks = 0